module.exports = "module.exports = __webpack_public_path__ + \"415c08fb1ba0c3f77587688b3dd0cbf6.obj\";"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/assets/windTurbine.obj
// module id = 4
// module chunks = 0